import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { getStaticProposalBySlug } from '../../../data/staticProposals';
import TnoConStyleCommercialProposalView from '../TNOMediaKitBancoActivoMetas/TnoConStyleCommercialProposalView';

const SLUG = 'empire-keeway';

/**
 * Propuesta Empire Keeway × Comercio Corporativo (misma plantilla visual que Metas × Banco Activo).
 */
const LandingMediaKitEmpireKeeway = ({ themeMode: _themeMode }) => {
  const [proposal, setProposal] = useState(null);

  useEffect(() => {
    setProposal(getStaticProposalBySlug(SLUG));
  }, []);

  useEffect(() => {
    if (!proposal?.metaTitle) return undefined;
    document.title = proposal.metaTitle;
    const desc = document.querySelector('meta[name="description"]');
    if (desc && proposal.metaDescription) desc.setAttribute('content', proposal.metaDescription);
    return () => {
      document.title = 'TNO Media Kit | Anuncia con Nosotros';
    };
  }, [proposal]);

  if (!proposal) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
        <Typography color="textSecondary">Cargando propuesta…</Typography>
      </Box>
    );
  }

  return <TnoConStyleCommercialProposalView content={proposal.content || {}} />;
};

LandingMediaKitEmpireKeeway.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitEmpireKeeway;
